
import React from "react";
import * as styles from "./genericHero.module.scss";
import Img from "gatsby-image";
import { FacebookShareButton, TwitterShareButton, EmailShareButton } from 'react-share';
import { useLocation } from '@reach/router';
import { useLocale } from "../../../../hooks";
import { FacebookIcon, TwitterIcon, MailIcon } from "../../../../svgs/play";
import Helmet from 'react-helmet';

const GenericHero = ({
    socialIcons,
    subtitle,
    title,
    subheading,
    description,
    shortDescription,
    fluid,
    fluidMob,
    fluidIcon,
    altText,
    pageType,
    firstChild = false
}) => {
    const newTitle = title?.split('/');
    const shortDes = shortDescription?.split('/');
    const { href } = useLocation();
    const locale = useLocale();
    const yellowBG = (locale1, locale2, locale3, locale4, locale5, locale6) => {
        return locale === locale1 || locale === locale2 || locale === locale3 || locale === locale4 || locale === locale5 || locale === locale6;
    };

    return (
        <>
            {fluidMob && (
                <Helmet>
                    <link rel="preload" as="image" media="(min-width: 400.1px) and (max-width: 767px)" href={`${fluidMob.srcSet.split(/\s*,\s*/).slice(-1).join().split(" ")[0]}`} />
                    <link rel="preload" as="image" media="(max-width: 400px)" href={`${fluidMob.srcSet.split(/\s*,\s*/).slice(-2).join().split(" ")[0]}`} />
                </Helmet>
            )}
            <div className={`${styles.hero_container} ${!firstChild ? styles.container : ''}`}>
                <div className={`${styles.text_container} ${pageType === 'Purpose' && styles.purposePage}`}>
                    <Img loading={`${firstChild ? "eager" : "lazy"}`} fadeIn={!firstChild} fluid={fluidIcon} className={styles.icon} alt={altText || title || "icon image"} />
                    <p className={`${styles.black} ${styles.cat_title}`}>{subtitle}</p>
                    {description && <p className={styles.desc}>{description}</p>}
                    {newTitle && <h1>{newTitle.map((phrase, index) => <span key={index}>{phrase}</span>)}</h1>}
                    {subheading && <h1 className={styles.subHeading}>{subheading}</h1>}
                    {(!newTitle && !subheading) && <h1 className={styles.seoHeading}>Lipton Tea</h1>}
                    <div className={styles.shortDes}>
                        {shortDes?.map((phrase, index) => <span key={index}><p className={styles.black}>{phrase}</p></span>)}
                    </div>
                    {socialIcons && (
                        <div>
                            <FacebookShareButton url={href}><FacebookIcon width={45} height={45} color={yellowBG("en-AE", "ar-AE", "en-EG", "ar-EG", "en-CA", "fr-CA") ? "#ffffff" : "#ffd100"} /></FacebookShareButton>
                            <EmailShareButton url={href}><MailIcon width={45} height={45} color={yellowBG("en-AE", "ar-AE", "en-EG", "ar-EG", "en-CA", "fr-CA") ? "#ffffff" : "#ffd100"} /></EmailShareButton>
                            <TwitterShareButton url={href}><TwitterIcon width={45} height={45} color={yellowBG("en-AE", "ar-AE", "en-EG", "ar-EG", "en-CA", "fr-CA") ? "#ffffff" : "#ffd100"} /></TwitterShareButton>
                        </div>
                    )}
                </div>
                {fluidMob && (
                    <div className={`${styles.sml_img} ${styles.mobileImage}`}>
                        <div aria-hidden="true" style={{ width: '100%', paddingBottom: '142.364%' }}></div>
                        <picture>
                            <source media="(min-width: 400.1px) and (max-width: 767px)" srcSet={`${fluidMob.srcSet.split(/\s*,\s*/).slice(-1).join().split(" ")[0]}`} />
                            <source media="(max-width: 400px)" srcSet={`${fluidMob.srcSet.split(/\s*,\s*/).slice(-2).join().split(" ")[0]}`} />
                            <img src={fluidMob.src} loading="eager" alt={altText || "Hero Image"} />
                        </picture>
                    </div>
                )}
                <Img fluid={fluid} className={`${styles.bg_Img} ${fluidMob ? styles.desktopImage : styles.heroImage}`} alt={altText || "Hero Image"} loading="eager" fadeIn={false} />
                <div className={styles.icons_wrapper}></div>
            </div>
            <p className={styles.article_title}></p>
        </>
    );
};

export default GenericHero;


